import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Row } from "reactstrap";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { mapSearchAutoSuggestion } from "../../../utils/mapper";
import { getUsersApi } from "../../../services/manage-user/user";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const customMultiStyles = {
  ...customStyles,

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#656E78",
    color: "#fff",
    // borderRadius: "4px",
    padding: "2px 4px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#fff",
    fontWeight: 500,
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: "#fff",
    ":hover": {
      backgroundColor: "#333",
      color: "#fff",
    },
  }),
};

function ApproveDeclineForm({ partnerState, onHandleSubmit, changeInvoiceLoading }) {
  const [reasons, setReasons] = useState([]);
  const [status, setStatus] = useState(0);
  const [selectReason, setSelectedReason] = useState(null);
  const [selectUser, setSelectedUser] = useState(null);
  const approveeReasons = [
    { value: 1, label: "Approved Reason 01" },
    { value: 2, label: "Approved Reason 02" },
    { value: 3, label: "Approved Reason 03" },
  ];

  useEffect(() => {
    if (partnerState && (partnerState.appDecDialog.isApprove === true || partnerState.appDecDialog.isApprove === false)) {
      if (partnerState.appDecDialog.isApprove === true) {
        setStatus(1);
        setReasons(partnerState.reconciliationSettings.approveReasons);
      } else if (partnerState.appDecDialog.isApprove === false) {
        setStatus(2);
        setReasons(partnerState.reconciliationSettings.declineReasons);
      }
    }
  }, [partnerState]);

  const userPromiseOption = (inputValue) =>
    new Promise((resolve) => {
      const data = {
        value: inputValue,
      };
      setTimeout(() => {
        resolve(mapSearchAutoSuggestion(getUsersApi(data)));
      });
    });

  return (
    <Fragment>
      <div style={{ padding: "20px" }}>
        <Row>
          <Col>
            <Select
              placeholder={status === 1 ? "Approve Reason" :"Decline Reason"}
              className="select2-filter"
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.id}
              isClearable
              options={reasons}
              styles={customMultiStyles}
              onChange={(selected) => {
                setSelectedReason(selected);
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
            />
          </Col>
          <Col>
            <Col>
              <AsyncSelect
                className="select2-filter"
                isClearable={true}
                cacheOptions
                defaultOptions
                placeholder="Approved By"
                loadOptions={userPromiseOption}
                styles={{
                  ...customStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 100 }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                onClear={(e) => {}}
                onChange={(e) => {
                  setSelectedUser(e ? e : null);
                }}
              />
            </Col>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col sm={12} className="d-flex justify-content-end">
            <Button
              color="success"
              // disabled={}
              onClick={(e) => {
                e.stopPropagation();
                const data = {
                  status,
                  selectReason,
                  selectUser,
                };
                if (!selectReason || !selectUser) return true;

                onHandleSubmit(data);
              }}
              disabled={changeInvoiceLoading}
            >
              {status === 1 ? (
                changeInvoiceLoading ? (
                  <>
                    {" "}
                    <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" /> Approve
                  </>
                ) : (
                  "Approve"
                )
              ) : status === 2 ? (
                changeInvoiceLoading ? (
                  <>
                    {" "}
                    <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" /> Declined
                  </>
                ) : (
                  "Declined"
                )
              ) : (
                ""
              )}
            </Button>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
}

export default ApproveDeclineForm;
